import Immutable from 'immutable';

import Link from '../../common/records/Link';
import NamedLink from '../../common/records/NamedLink';

export const CollectionLink = Immutable.Record({
  key: '',
  link: new NamedLink(),
  contentfulEntryId: '',
});

export const CollectionsLinks = Immutable.Record({
  collections: Immutable.List(),
});

export const CollectionsMetricsKeys = Immutable.Record({
  collection: '',
});

export default class CollectionsConfig extends Immutable.Record({
  links: new CollectionsLinks(),
  metricsKeys: new CollectionsMetricsKeys(),
}) {}

export const resolveCollectionsConfig = ({ appConfig }) =>
  new CollectionsConfig({
    links: new CollectionsLinks({
      collections: appConfig.getIn(['collections', 'links', 'collections']).map(
        c =>
          new CollectionLink({
            key: c.get('key'),
            link: new NamedLink({
              name: c.get('name'),
              link: new Link({
                href: c.getIn(['link', 'href']),
              }),
            }),
            contentfulEntryId: c.get('contentfulEntryId'),
          })
      ),
      metricsKeys: new CollectionsMetricsKeys({
        collection: appConfig.getIn(['collections', 'metricsKeys', 'collection']),
      }),
    }),
  });
